import { render, staticRenderFns } from "./NotesStudentDialog.vue?vue&type=template&id=0d966866&scoped=true"
import script from "./NotesStudentDialog.vue?vue&type=script&lang=js"
export * from "./NotesStudentDialog.vue?vue&type=script&lang=js"
import style0 from "./NotesStudentDialog.vue?vue&type=style&index=0&id=0d966866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d966866",
  null
  
)

export default component.exports